var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('timeline-card', {
    attrs: {
      "title": _vm.$t('timeLine.PartnerRegistrationTimeLineElement.title')
    }
  }, [_c('Can', {
    attrs: {
      "I": _vm.ActionEnum.UPDATE,
      "a": _vm.ResourceEnum.REPORT
    }
  }, [_c('template', {
    slot: "menu"
  }, [_c('registration-update-dialog', {
    attrs: {
      "icon": false,
      "loading": _vm.loading,
      "registration": _vm.registration,
      "registrationImageLink": _vm.registrationImageLink
    },
    on: {
      "update": _vm.update
    }
  })], 1)], 2), _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [!_vm.loading ? _c('v-data-table', {
    attrs: {
      "dense": "",
      "item-key": "key",
      "headers": _vm.headers,
      "items": _vm.notEmptyData,
      "hide-default-header": "",
      "hide-default-footer": "",
      "disable-pagination": ""
    }
  }) : _vm._e()], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }